import { formatMoney } from '../../lib/formatters.ts'
import type { ForecastWeek } from '../../api/cashReport'
import { weekOutDollars } from './headlines.ts'

type Props = {
  weeks: ForecastWeek[]
  onOpenWeek: (weekStart: string) => void
}

function closeDollars(w: ForecastWeek): number | null {
  if (w.close && Number.isFinite(w.close.amount)) return w.close.amount
  if (w.close_cents != null) return Number(w.close_cents) / 100
  return null
}

export default function WeeklyTable({ weeks, onOpenWeek }: Props) {
  return (
    <div data-testid="cr-weekly-table">
      <table className="cr-table">
        <thead>
          <tr>
            <th>Week</th>
            <th>Expected in</th>
            <th>Expected out</th>
            <th>Closing cash</th>
          </tr>
        </thead>
        <tbody>
          {weeks.map((w) => {
            const close = closeDollars(w)
            const inn = w.in?.amount ?? 0
            const out = weekOutDollars(w)
            return (
              <tr
                key={w.week_start}
                className={w.below_zero || w.below_cushion ? 'short' : undefined}
              >
                <td>
                  <button type="button" onClick={() => onOpenWeek(w.week_start)}>
                    {w.week_start}
                  </button>
                </td>
                <td>{formatMoney(inn)}</td>
                <td>{formatMoney(out)}</td>
                <td>
                  <button
                    type="button"
                    data-testid={`cr-week-close-${w.week_start}`}
                    onClick={() => onOpenWeek(w.week_start)}
                  >
                    {close == null ? '—' : formatMoney(close)}
                  </button>
                </td>
              </tr>
            )
          })}
        </tbody>
      </table>
    </div>
  )
}
